import axios from "../../../axios";

export const downloadStudio = async (worker_id) => {
  try {
    let { data } = await axios.get(`/v1/worker/download`);
    return data;
  } catch (e) {
    console.log("error while getting workers setting data", e);
  }
};
